import React, { useState } from 'react';
import PropTypes from 'prop-types';

import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';

import { AUTH_FORM_TYPES } from '../utils/constants';
import SignupForm from './SignupForm';
import LoginForm from './LoginForm';
import BuyerAuthModalFooter from './BuyerAuthModalFooter';

export default function BuyerApplicationAuthModal({
  onCloseClick,
  onSuccessfulAuth
}) {
  const [formType, setFormType] = useState(AUTH_FORM_TYPES.SIGNUP);

  return (
    <MiniOverlayModal
      className="BuyerApplicationAuthModal"
      onCloseClick={onCloseClick}
    >
      <div className="ph20-md ph6 pt10">
        {formType === AUTH_FORM_TYPES.LOGIN && (
          <>
            <LoginForm
              buttonText="Continue"
              headerText="Log in to apply"
              onSuccessfulAuth={onSuccessfulAuth}
            />
            <BuyerAuthModalFooter
              linkedFormType={AUTH_FORM_TYPES.SIGNUP}
              onToggleFormTypeClick={setFormType}
            />
          </>
        )}
        {formType === AUTH_FORM_TYPES.SIGNUP && (
          <>
            <SignupForm
              buttonText="Continue"
              headerText="Create an account to apply"
              subHeaderText="Save your application progress and easily stay in touch with breeders by creating an account"
              onSuccessfulAuth={onSuccessfulAuth}
            />
            <BuyerAuthModalFooter
              linkedFormType={AUTH_FORM_TYPES.LOGIN}
              onToggleFormTypeClick={setFormType}
            />
          </>
        )}
      </div>
    </MiniOverlayModal>
  );
}

BuyerApplicationAuthModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onSuccessfulAuth: PropTypes.func.isRequired
};
